import { colors } from '@/lib/analytics/colors';
import { SIZE_33 } from '@/lib/gridElements/size';
import { KPI_VALUE_CLASSIC } from '@/utils/hooks/format/useFormatKpiValue';
import { KPIDefault } from '@/components/base/Kpi/KpiDefault';
import { DefaultLoader } from '@/components/base/Kpi/KpiLoader';

export const savesConfig = {
    name: 'kpi.instagram.saves',
    id: 'saves',
    icon: {
        name: 'collections',
        style: colors.pink
    },
    tooltip: 'kpi.instagram.tooltip_saves',
    growth_tooltip: {
        up: 'analytics:kpi.growth_tooltip.up',
        down: 'analytics:kpi.growth_tooltip.down',
        still: 'analytics:kpi.growth_tooltip.still'
    },
    data_format: KPI_VALUE_CLASSIC,
    size: SIZE_33,
    type: 'kpi',
    loader: DefaultLoader,
    element: KPIDefault
};
